import React from 'react';
import FixedDataTable from '@shoflo-rundown/fixed-data-table';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import EventViewStore from 'flux/stores/EventViewStore';
import GlobalElementStore from 'flux/stores/GlobalElementStore';
import GlobalElementModalActions from 'flux/actions/GlobalElementModalActions';
import PermissionStore from 'flux/stores/PermissionStore';
import {
  RowTypes,
  EditableCellTypes,
  HeaderHeight,
  CompactHeaderHeight,
  CompactSpecialColumnWidths,
  DefaultRowHeightWithDescription,
  DefaultRowHeight,
  DefaultCompactRowHeight,
  DefaultGlobalElementRowHeight,
  DefaultTitleRowHeight,
  ItemColumnSegmentWidths,
  CellBorders,
  CellPaddings,
  ReadOnlyCellAddonHeightWithPersonalHighlight,
} from 'flux/stores/cuesheet/CuesheetConstants';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import PopoverStore from 'flux/stores/PopoverStore';
import ItemCell from './itemCell/itemCell.jsx';
import CompactItemCell from 'main/components/show/cuesheet.compact/itemCell/itemCell.jsx';
import GlobalElementItemCell from 'main/components/show/cuesheet.globalElement/itemCell/itemCell.jsx';
import RowMenuCell from 'main/components/show/cuesheet.globalElement/rowMenuCell/rowMenuCell.jsx';
import LabelCell from 'main/components/show/cuesheet.globalElement/labelCell/labelCell.jsx';
import DataCell from './dataCell.jsx';
import NoteCell from './noteCell.jsx';
import HighlightHelper from './highlightCellHelper';

import ProofOfPerformanceCell from './proofOfPerformanceCell';
import ProofColumnHeaderCell from './columnHeaderCell/proofColumnHeaderCell';
import DataColumnHeaderCell from './columnHeaderCell/dataColumnHeaderCell.jsx';
import NoteColumnHeaderCell from './columnHeaderCell/noteColumnHeaderCell.jsx';
import ItemColumnHeaderCell from './columnHeaderCell/itemColumnHeaderCell.jsx';

import {
  durationCellRenderer,
  presetDurationCellRenderer,
  startTimeCellRenderer,
} from 'main/components/show/cuesheet.util/cellRenderers';

import SimpleHeaderCell from 'main/components/show/cuesheet.util/SimpleHeaderCell';
import NavigationMixin from './navigationMixin';
import HotKeyMixin from './hotKeyMixin';
import Reflux from 'reflux';
import keyIn from 'shared/lib/immutable/keyIn';
import RowHeightHelper from './rowHeightHelper';

import {
  getDataCellWidthName,
  getNoteCellWidthName,
  getItemCellWidthName,
  getCompactItemCellWidthName,
  getGlobalItemCellWidthName,
} from './rowWidthHelper';

import AddColumnButton from 'main/components/show/cuesheet/addColumnButton.jsx';
import AddItemButton from 'main/components/show/cuesheet/addItemButton.jsx';
import classNames from 'classnames';
import CuesheetMixin from 'main/components/show/cuesheet/cuesheetMixin';
import CuesheetHelper from 'flux/helpers/cuesheetHelper';
import CuesheetPopulateMixin from 'main/components/show/cuesheet/cuesheetPopulateMixin.js';
import Spinner from 'shared/components/misc/simpleSpinner.jsx';
import CuesheetCueClockStore from 'flux/stores/cuesheet/CuesheetCueClockStore';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { ViewTypes } from 'shared/constants/CuesheetViews';

import AddTagMenu from 'shared/components/tag/addTagMenu';
import { Icon } from '@shoflo-rundown/polymer.legacy';

const Table = FixedDataTable.Table,
  Column = FixedDataTable.Column;

const debug = require('debug')('shoflo:cuesheet:cuesheet.jsx');

/**
 * Default Export
 *
 * @param  {[type]} viewType [description]
 * @return [type]            [description]
 */
const cuesheetHoc = (viewType) => {
  const isGlobalElementView = viewType === ViewTypes.GlobalElement;
  const isCompactView = viewType === ViewTypes.Compact;

  const defaultRowHeightDesc =
    isCompactView || isGlobalElementView
      ? DefaultCompactRowHeight
      : DefaultRowHeightWithDescription;

  let defaultRowHeight = isCompactView
    ? DefaultCompactRowHeight
    : DefaultRowHeight;

  if (isGlobalElementView) {
    defaultRowHeight = DefaultGlobalElementRowHeight;
  }

  const itemCellLookup = {
    [ViewTypes.Loose]: ItemCell,
    [ViewTypes.Compact]: CompactItemCell,
    [ViewTypes.GlobalElement]: GlobalElementItemCell,
  };

  const ItemCellComponent = itemCellLookup[viewType];

  const cellBorderOffset =
    isCompactView || isGlobalElementView
      ? CellBorders.Compact
      : CellBorders.Loose;
  const cellPaddingOffset =
    isCompactView || isGlobalElementView
      ? CellPaddings.Compact
      : CellPaddings.Loose;

  /**
   * Get the height for the grid
   *
   * @returns {number}
   * @private
   */
  function _getGridHeight() {
    const innerHeight = window.innerHeight;
    let showHeader = document.getElementById('cs-header');
    let showFooter = document.getElementById('cs-footer');
    let buffer = 2;

    if (isGlobalElementView) {
      showHeader = document.getElementById('ge-em-headers-wrapper');
      showFooter = document.getElementById('ge-metrics-footer');
      buffer = -12;
    }

    const showHeaderHeight = showHeader ? showHeader.offsetHeight : 69;
    const showFooterHeight = showFooter ? showFooter.offsetHeight : 68;

    const newHeight =
      innerHeight + buffer - showHeaderHeight - showFooterHeight;

    return newHeight;
  }

  let rowHeights = {};

  return React.createClass({
    displayName: 'ShowCuesheet',

    mixins: [
      Reflux.ListenerMixin,
      Reflux.connectFilter(EventViewStore, 'event', (st) =>
        st.filter(keyIn('twentyFourHourClock', 'timeZone', 'team', '_id')),
      ),
      Reflux.connect(CuesheetStore, 'cuesheet'),
      Reflux.connect(PermissionStore, 'permissions'),
      Reflux.connect(GlobalElementStore, 'globalElements'),
      Reflux.connect(UserSessionStore, 'user'),
      Reflux.connectFilter(PopoverStore, 'popoverVisible', (st) =>
        st.find((val) => val),
      ),
      Reflux.connectFilter(
        CuesheetCueClockStore,
        'toggleFullScreenClock',
        (state) => state.get('toggleFullScreenClock'),
      ),
      NavigationMixin,
      HotKeyMixin,
      CuesheetMixin,
      CuesheetPopulateMixin,
      PureRenderMixin,
    ],

    componentWillMount() {
      CuesheetActions.setCopyStateFromSession();
      RowHeightHelper.init();
    },

    componentDidMount() {
      this.listenTo(
        CuesheetRowActions.bustRowHeightCache,
        this._forceRowHeights,
      );
    },

    componentWillUnmount() {
      rowHeights = {};
    },

    componentDidUpdate(prevProps, prevState) {
      const prev = prevState.cuesheet,
        curr = this.state.cuesheet;

      if (prev && curr && !prev.get('rows') && curr.get('rows')) {
        this._initializeAllRowHeights();
      }

      //once we have scrolled to the offset, clear the scroll indexes so the user isnt scrolled again
      //every time the cuesheet updates
      if (curr.get('scrollRowIndex') || curr.get('scrollRowWithOffsetIndex')) {
        CuesheetActions.clearScrollIndexes();
      }
    },

    _forceRowHeights(rowIds) {
      if (!rowIds) {
        rowHeights = {};
      } else {
        if (!Array.isArray(rowIds)) rowIds = [rowIds];
        rowIds.forEach((rowId) => {
          rowHeights[rowId] = undefined;
        });

        this.forceUpdate();
      }
    },

    render() {
      const {
        cuesheet,
        user,
        globalElements,
        permissions,
        popoverVisible,
      } = this.state;

      const tags = globalElements.get('tags'),
        rows = this._getRows(),
        scrollRowIndex = cuesheet.get('scrollRowIndex'),
        scrollRowWithOffsetIndex = cuesheet.get('scrollRowWithOffsetIndex');

      const scrollColumnIndex = cuesheet.get('scrollColumnIndex');

      let contentNode = <Spinner />;

      const loadFailureNode = this.getLoadFailureNode(_getGridHeight());

      if (loadFailureNode) contentNode = loadFailureNode;

      const validRows = rows && rows.size;
      const validTags = tags && tags.size;
      const isLoadingData =
        cuesheet.get('loading') || permissions.get('loading');

      if (
        (isGlobalElementView && !isLoadingData && validRows && validTags) ||
        (!isGlobalElementView && !isLoadingData && validRows)
      ) {
        /**
         * Don't set scrollIndex/scroll offset props if there is a visible popover. Reference https://github.com/SHOFLO/Issues/issues/1283
         */
        const optionalProps = {};

        if (scrollRowIndex >= 0 && !popoverVisible)
          optionalProps.scrollToRow = scrollRowIndex;
        if (typeof scrollRowWithOffsetIndex !== 'undefined' && !popoverVisible)
          optionalProps.scrollToRowWithOffset = scrollRowWithOffsetIndex;

        contentNode = (
          <Table
            onScrollStart={() => {
              this.setState({ userStartedScrolling: true });
            }}
            rowClassNameGetter={this._rowClassNameGetter}
            rowGetter={this._rowGetter}
            rowsCount={rows.size + 1}
            {...optionalProps}
            scrollToColumn={scrollColumnIndex}
            rowHeight={defaultRowHeight}
            rowHeightGetter={this._rowHeightGetter}
            {...this._calculateTableProps()}
          >
            {this._getColumns()}
          </Table>
        );
      }

      /**
       * Prevent text from being highlighted when selected multiple cells with the
       * shift key.
       */
      let cuesheetClasses = classNames('cuesheet', 'disable-text-highlight', {
        'cuesheet-light': user.get('cuesheetTheme') === 'light',
        'cuesheet-compact': isCompactView,
        'cuesheet-compact cuesheet-global': isGlobalElementView,
        'cuesheet-global-no-content': !validRows || validRows.size < 1,
      });

      let noContentNode = null;

      if (
        ((isGlobalElementView && !validRows) ||
          (validRows && validRows.size < 1)) &&
        !isLoadingData
      ) {
        noContentNode = this._getNoRowsNode('No results matched your filter.');
      }

      let cursorLoadingNode = null;

      if (isLoadingData) {
        cursorLoadingNode = <div className="cs-loading-cursor"></div>;
      }

      return (
        <div className={cuesheetClasses}>
          {cursorLoadingNode}
          {noContentNode ? noContentNode : contentNode}
        </div>
      );
    },

    _filterGlobalElementManagerRows(tagIds) {
      CuesheetRowActions.filterGlobalElementManagerRows('label', tagIds);
    },

    _clearGlobalElementManagerRowsFilter() {
      CuesheetRowActions.clearGlobalElementManagerRowsFilter('label');
    },

    _getNoRowsNode(msgTitle) {
      const isGlobalElementView = viewType === ViewTypes.GlobalElement;
      if (!isGlobalElementView) return null;

      const { cuesheet, globalElements } = this.state;

      // Show filter menus in case a filter returns no rows
      // allows user to clear the filters
      return (
        <div className="ge-no-content">
          <div className="ge-em-header-filter main">
            <AddTagMenu
              displayLabel="Tag"
              activeTagId={cuesheet.get('labelFilter')}
              tags={globalElements.get('tags')}
              placement="bottom"
              popoverId="addTagFilterMenu"
              isFilter
              caretIcon={<Icon name="angle-down" />}
              onChange={this._filterGlobalElementManagerRows}
              onClear={this._clearGlobalElementManagerRowsFilter}
            />
          </div>
          <h1>{msgTitle}</h1>
          <div>
            <AddItemButton />
          </div>
        </div>
      );
    },

    _getUserState() {
      return this.state.user;
    },

    _getCuesheetState() {
      return this.state.cuesheet || {};
    },

    /**
     * Calculate some table properties, mostly for dimensions
     */
    _calculateTableProps() {
      const docEl = document.documentElement;

      const { innerWidth } = window;

      const gridWidth = Math.max(docEl.clientWidth, innerWidth || 0);

      const headerHeight =
        !isCompactView || !isGlobalElementView
          ? HeaderHeight
          : CompactHeaderHeight;

      return {
        headerHeight,
        width: gridWidth - 20,
        height: _getGridHeight(), //Not sure why, but this seems to prevent the FDT from expanding its height irregularly...if I put it at .95, it does odd things)
      };
    },

    _getColumns() {
      const { event, user } = this.state;

      const columnData = this._getCueStateField('columns'),
        userSettings = this._getCueStateField('userSettings'),
        settings = this._getCueStateField('settings'),
        show = this._getCueStateField('show');

      let widthClass = isCompactView
        ? getCompactItemCellWidthName(settings)
        : getItemCellWidthName(settings);
      if (isGlobalElementView) widthClass = getGlobalItemCellWidthName();

      const displayNotes = !userSettings.getIn(['noteColumn', 'hidden']),
        displayStartTime = show.get('displayStartTime'),
        displayPresetDuration = show.get('displayPresetDuration'),
        displayDuration = show.get('displayDuration'),
        displayProofOfPerformance = user.getIn([
          'preferences',
          'displayProofOfPerformance',
        ]);

      let dataCellScrollRenderer = null,
        noteCellScrollRenderer = null,
        proofCellScrollRenderer = null;

      if (
        this._getCueStateField('rows').size > this._getInitialRowCountRender()
      ) {
        noteCellScrollRenderer = this._scrollingCellRenderer.bind(
          null,
          'cs-note-cell',
        );
        dataCellScrollRenderer = this._scrollingCellRenderer.bind(
          null,
          'cs-data-cell',
        );
        proofCellScrollRenderer = this._scrollingCellRenderer.bind(null, '');
      }

      const rowMenuColumn = (
        <Column
          key="column-label"
          label=""
          width={60}
          dataKey="rowMenu"
          fixed={false}
          cellDataGetter={this._rowDataGetter}
          cellRenderer={this._rowMenuCellRenderer}
          cellClassName="cs-row-menu-column"
          headerRenderer={this._simpleColumnHeaderRenderer}
        />
      );

      const labelColumn = (
        <Column
          key="column-label"
          label="Tags"
          width={162}
          dataKey="label"
          fixed={false}
          cellDataGetter={this._rowDataGetter}
          cellRenderer={this._labelCellRenderer}
          cellClassName={'cs-label-column cs-cell-width-' + widthClass}
          headerRenderer={this._simpleColumnHeaderRenderer}
        />
      );

      /**
       * Define the item column
       */
      const itemColumn = (
        <Column
          allowCellsRecycling
          key="column-item"
          label="Item"
          width={this._getItemColumnWidth()}
          dataKey="item"
          fixed={false}
          cellDataGetter={this._rowDataGetter}
          cellRenderer={this._itemCellRenderer}
          cellClassName={'cs-item-column cs-cell-width-' + widthClass}
          headerRenderer={this._itemColumnHeaderRenderer}
        />
      );

      const noteColumn = (
        <Column
          allowCellsRecycling
          key="column-notes"
          label="Notes"
          width={this._getColumnWidth(
            userSettings.getIn(['noteColumn', 'width']),
          )}
          cellClassName={
            'cs-note-column cs-cell-width-' + getNoteCellWidthName(userSettings)
          }
          dataKey="notes"
          fixed={false}
          cellDataGetter={this._rowDataGetter}
          cellScrollingRenderer={noteCellScrollRenderer}
          cellRenderer={this._noteCellRenderer}
          headerRenderer={this._noteColumnHeaderRenderer}
        />
      );

      /* eslint-disable no-unused-vars */
      const cellRendererArgs = [
        event,
        show,
        user,
        (rowSpec) => this._getRowItem(rowSpec),
        this.state.cuesheet,
      ];

      const startTimeColumn = (
        <Column
          allowCellsRecycling
          key={'start-time'}
          label="Start"
          width={isCompactView ? CompactSpecialColumnWidths.Start : 96}
          dataKey={'startTime'}
          fixed={false}
          cellClassName={'cs-special-column-start cs-special-column'}
          cellDataGetter={this._rowDataGetter}
          cellRenderer={this._startTimeCellRenderer}
          cellScrollingRenderer={dataCellScrollRenderer}
          headerRenderer={this._simpleColumnHeaderRenderer}
        />
      );

      let presetLabel =
        show.get('presetDurationDisplayType') === TimeDisplayTypes.clockTime
          ? 'Clock Time'
          : 'Preset';

      const presetDurationColumn = (
        <Column
          allowCellsRecycling
          key={'presetDuration'}
          label={presetLabel}
          width={isCompactView ? CompactSpecialColumnWidths.Preset : 96}
          dataKey={'presetDuration'}
          fixed={false}
          cellClassName={'cs-special-column-preset cs-special-column'}
          cellDataGetter={this._rowDataGetter}
          cellScrollingRenderer={dataCellScrollRenderer}
          cellRenderer={this._presetDurationCellRenderer}
          headerRenderer={this._simpleColumnHeaderRenderer}
        />
      );

      const durationColumn = (
        <Column
          allowCellsRecycling
          key={'duration'}
          label="Duration"
          width={isCompactView ? CompactSpecialColumnWidths.Duration : 110}
          dataKey={'duration'}
          fixed={false}
          cellClassName={'cs-special-column-duration cs-special-column'}
          cellDataGetter={this._rowDataGetter}
          cellScrollingRenderer={dataCellScrollRenderer}
          cellRenderer={this._durationCellRenderer}
          headerRenderer={this._simpleColumnHeaderRenderer}
        />
      );

      const proofOfPerformanceColumn = (
        <Column
          allowCellsRecycling
          key={'proofOfPerformance'}
          label="Timestamp"
          width={isCompactView ? CompactSpecialColumnWidths.Proof : 238}
          dataKey={'proofOfPerformance'}
          fixed={false}
          cellDataGetter={this._rowDataGetter}
          cellScrollingRenderer={proofCellScrollRenderer}
          cellRenderer={this._proofOfPerformanceRenderer}
          headerRenderer={
            show.get('proofOfPerformanceTracking')
              ? this._proofColumnHeaderRendererWithTracking
              : this._proofColumnHeaderRenderer
          }
        />
      );

      const specialColumnLookupGetter = {
        [ViewTypes.Loose]: () => {
          let columns = [itemColumn];
          if (displayProofOfPerformance) columns.push(proofOfPerformanceColumn);
          if (displayNotes) columns.push(noteColumn);
          return columns;
        },
        [ViewTypes.Compact]: () => {
          let columns = [itemColumn];
          if (displayStartTime) columns.push(startTimeColumn);
          if (displayPresetDuration) columns.push(presetDurationColumn);
          if (displayDuration) columns.push(durationColumn);
          if (displayProofOfPerformance) columns.push(proofOfPerformanceColumn);
          if (displayNotes) columns.push(noteColumn);
          return columns;
        },
        [ViewTypes.GlobalElement]: () => {
          let columns = [rowMenuColumn, labelColumn, itemColumn];
          if (displayDuration) columns.push(durationColumn);
          return columns;
        },
      };

      /**
       * Build data columns list
       */
      const dataColumns = columnData
        .map((column, indx) => {
          return (
            <Column
              allowCellsRecycling
              key={'column-data-' + column.get('_id')}
              label={column}
              width={this._getColumnWidth(column.get('width'))}
              dataKey={column.get('_id')}
              fixed={false}
              cellDataGetter={this._dataCellDataGetter}
              cellRenderer={this._dataCellRenderer}
              cellScrollingRenderer={dataCellScrollRenderer}
              cellClassName={
                'cs-data-column cs-cell-width-' + getDataCellWidthName(column)
              }
              headerRenderer={this._dataColumnHeaderRenderer}
            />
          );
        })
        .filter((col) => col)
        .toArray();

      /**
       * Build the add column button column
       */
      const addButtonColumn = (
        <Column
          key={'column-add-new'}
          label={''}
          width={250}
          dataKey={'addColumn'}
          fixed={false}
          cellRenderer={this._emptyCellRenderer}
          headerRenderer={this._buttonHeaderRenderer}
        />
      );

      /**
       * Aggregate all the columns and return
       */
      let specialColumns = specialColumnLookupGetter[viewType]();
      return specialColumns.concat(dataColumns, [addButtonColumn]);
    },

    _scrollingCellRenderer(extraClassNames = '', { rowIndex }) {
      const state = this.state.cuesheet,
        rowSpec = state.getIn(['rows', rowIndex]);

      if (!rowSpec) return <span />;

      const item = this._getRowItem(rowSpec);

      const titleView = item.get('titleView');

      const className = classNames(
        'text-center',
        'cs-cell-scrolling',
        'cs-cell',
        extraClassNames,
        { 'cs-title-cell': titleView },
      );
      const style = Object.assign(
        {
          color: '#fff',
          width: '100%',
          height: '100%',
        },
        HighlightHelper.getPersonalHighlightStyle(
          item,
          this._getCueStateField('userId'),
        ),
        HighlightHelper.getGlobalHighlightStyle(item),
      );

      return <div {...{ style, className }}>...</div>;
    },

    /**
     * Header cell renderer for item column
     */
    _itemColumnHeaderRenderer() {
      return (
        <ItemColumnHeaderCell settings={this._getCueStateField('settings')} />
      );
    },

    /**
     * Simple, non-interactive header cell renderer
     *
     * @param  {[type]} label [description]
     * @return [type]         [description]
     */
    _simpleColumnHeaderRenderer(label) {
      return <SimpleHeaderCell>{label}</SimpleHeaderCell>;
    },

    /**
     * Header cell renderer for note column
     */
    _noteColumnHeaderRenderer() {
      return (
        <NoteColumnHeaderCell
          userSettings={this._getCueStateField('userSettings')}
        />
      );
    },

    /**
     * Header cell renderer for proof of performance column
     */
    _proofColumnHeaderRenderer() {
      return <ProofColumnHeaderCell user={this.state.user} />;
    },

    _proofColumnHeaderRendererWithTracking() {
      return (
        <ProofColumnHeaderCell
          proofOfPerformanceTracking
          user={this.state.user}
        />
      );
    },

    /**
     * Header cell renderer for add column button column
     */
    _buttonHeaderRenderer() {
      return <AddColumnButton />;
    },

    /**
     * Header cell renderer for data columns
     */
    _dataColumnHeaderRenderer(column, columnId, columnData, rowData, width) {
      const state = this._getCueState(),
        show = this._getCueStateField('show'),
        teamId = this._getCueStateField('teamId'),
        eventId = this._getCueStateField('eventId'),
        { event } = this.state;

      return (
        <DataColumnHeaderCell
          isEditing={state.getIn(['columns', columnId, 'editing'])}
          isSelected={state.getIn(['columns', columnId, 'selected'])}
          column={column}
          teamId={teamId}
          eventId={eventId}
          showId={show.get('_id')}
        />
      );
    },

    /**
     * Gets the class name for the row...used by the FDT
     */
    _rowClassNameGetter(indx) {
      //Classes for footer row
      if (this._isFooterRow(indx)) return '';

      const rowSpec = this._rowGetter(indx);
      if (!rowSpec) return '';
      const rowType = rowSpec.get('type');

      // added t-row + index for ghostinspector test instrumentation
      let rowClassName = 'cs-row ' + 't-row-' + indx;

      if (rowType === RowTypes.TitleItem) rowClassName += ' cs-row-title';

      if (rowSpec.get('tracked')) rowClassName += ' cs-row-tracked';

      if (rowSpec.get('rowSelected')) rowClassName += ' cs-row-selected-bulk';

      if (!rowSpec.get('editing') && !rowSpec.get('selected'))
        return rowClassName;

      return rowClassName + ' cs-row-selected';
    },

    _cellHeightGetter(rowIndex, titleView) {
      let height =
        this._rowHeightGetter(rowIndex) - cellPaddingOffset - cellBorderOffset;

      if ((isGlobalElementView || isCompactView) && titleView) {
        height -= CellPaddings.CompactTitle; // subtract title border padding in compact view
      }

      return height;
    },

    _initializeRowHeight(index) {
      const rowSpec = this._rowGetter(index);
      if (rowSpec && rowSpec.get) {
        const item = this._getRowItem(rowSpec);
        const itemId = item.get('_id');
        rowHeights[itemId] = this._rowHeightGetter(index);
      }
    },

    _getInitialRowCountRender() {
      let initialRowCountRender = 20;
      if (isCompactView) initialRowCountRender = 30;

      return initialRowCountRender;
    },

    _initializeAllRowHeights() {
      const state = this.state.cuesheet;

      const rows = state.get('rows');

      if (!rows) return;

      const rowCount = rows.size;

      let index = 0;

      const rafRowHeightCalculator = () => {
        this._initializeRowHeight(index);
        index++;
        if (index < rowCount) {
          return window.requestAnimationFrame(rafRowHeightCalculator);
        }
      };

      window.requestAnimationFrame(rafRowHeightCalculator);
    },

    /**
     * Helper function for _rowHeightGetter()
     */
    _getRowHeight(item, rowType, rowId) {
      if (rowHeights[rowId]) {
        return rowHeights[rowId];
      }

      debug('getting row height for row', item.get('numberAdjusted'));

      const cellsWithState = item
        .get('cells')
        .filter((cell) => cell && cell.get('rteState'));

      let defaultHeight = this._getCueState().getIn([
        'show',
        'displayItemDescriptions',
      ])
        ? defaultRowHeightDesc
        : defaultRowHeight;

      if (rowType === RowTypes.TitleItem) {
        defaultHeight =
          isGlobalElementView || isCompactView
            ? DefaultCompactRowHeight
            : DefaultTitleRowHeight;
      }

      let heights = cellsWithState
        .map((cell, columnId) =>
          this._getCellHeight(cell, columnId, item, rowId),
        )
        .set('notes', this._getNoteCellHeight(item, rowId))
        .set('item', this._getItemCellHeight(item, rowId))
        .set('proof', this._getProofCellHeight(item, rowId));

      if (isGlobalElementView) {
        const labels = this._getRowTagsByRowId(rowId);
        heights = heights.set(
          'labels',
          this._getLabelsCellHeight(item, labels, rowId),
        );
      }

      const personalHighlights = HighlightHelper.getPersonalHighlightStyle(
        item,
        this._getCueStateField('userId'),
      );

      const personalHighlightOffset =
        isCompactView && personalHighlights
          ? ReadOnlyCellAddonHeightWithPersonalHighlight
          : 0;

      const largest =
        heights.max() + cellBorderOffset + personalHighlightOffset;

      const height = largest < defaultHeight ? defaultHeight : largest;
      rowHeights[rowId] = height;

      return height;
    },

    _getItemCellHeight(item, rowId) {
      const styles = this._getCommonCellHeightCalcStyles(),
        itemWidth = this._getItemColumnSegmentWidth(),
        descClassName = 'cs-desc-cell ' + className,
        displayDuration = this._getCueState().getIn([
          'show',
          'displayDuration',
        ]),
        displayPresetDuration = this._getCueState().getIn([
          'show',
          'displayPresetDuration',
        ]),
        displayStartTime = this._getCueState().getIn([
          'show',
          'displayStartTime',
        ]),
        titleView = item.get('titleView'),
        segmentState = item.get('rteTitleState'),
        compactViewBorder = 0;

      let className = 'cs-cell cs-cell-format',
        descHeight = 0,
        minDescHeight = 0,
        descCellMargin = 0,
        cellPadding = CellPaddings.Loose,
        clockHeight = 13,
        clockMargin = 8,
        corruptedCell = false,
        segmentClassName = 'cs-segment-cell ' + className;

      if (titleView) {
        segmentClassName += ' cs-title-cell';
      }

      if (!displayStartTime && !displayPresetDuration && !displayDuration)
        clockHeight = 0;

      if (itemWidth === ItemColumnSegmentWidths.Narrow) {
        if (
          (displayStartTime && displayDuration) ||
          (displayPresetDuration && displayDuration)
        ) {
          clockHeight = 32;
        }
      }

      if (itemWidth === ItemColumnSegmentWidths.UltraNarrow) {
        if (
          (displayDuration && displayStartTime) ||
          (displayDuration && displayPresetDuration) ||
          (displayStartTime && displayPresetDuration)
        ) {
          clockHeight = 32;
        }
        if (displayDuration && displayStartTime && displayPresetDuration) {
          clockHeight = 48;
        }
      }

      let segmentHeight = 0;
      let minSegmentHeight = titleView ? 27 : 23;

      if (isGlobalElementView || isCompactView) {
        clockHeight = clockMargin = 0;
        minSegmentHeight = titleView ? 53 : 23;
      }

      segmentHeight = this._getRowHeightWithErrorHandler(
        itemWidth,
        segmentState,
        styles,
        segmentClassName,
        () => (corruptedCell = true),
      );

      segmentHeight =
        segmentHeight > minSegmentHeight ? segmentHeight : minSegmentHeight;

      if (
        this._getCueState().getIn(['show', 'displayItemDescriptions']) &&
        !titleView &&
        (!isCompactView || !isGlobalElementView)
      ) {
        const descState = item.get('rteDescriptionState');

        minDescHeight = 20;
        descCellMargin = 10;

        descHeight = this._getRowHeightWithErrorHandler(
          itemWidth,
          descState,
          styles,
          descClassName,
          () => (corruptedCell = true),
        );

        descHeight = descHeight > minDescHeight ? descHeight : minDescHeight;
      }

      descHeight += descCellMargin;
      clockHeight += clockMargin;

      if (isCompactView || isGlobalElementView) {
        cellPadding = 0; // cellPadding is calculated in the rowHeightHelper for compact view
        descHeight = 0;
      }

      const displayActualDuration = this._getCueState().getIn([
        'show',
        'displayActualDuration',
      ]);

      let actualDurationHeight = 0;
      const hasOverUnderPermission = this.state.permissions.get('overUnder');

      const rowSpec = this._getRows().find((spec) => {
        return this._getRowId(spec) === rowId;
      });
      const isTracked = rowSpec.get('tracked');
      const display =
        displayActualDuration &&
        (item.get('actualDurationInSeconds') !== undefined || isTracked);

      if (display && hasOverUnderPermission) {
        if (isTracked) {
          actualDurationHeight = 22;
        } else {
          actualDurationHeight = 18;
        }
      }

      let fullHeight =
        segmentHeight +
        descHeight +
        clockHeight +
        cellPadding +
        compactViewBorder +
        actualDurationHeight;

      fullHeight = corruptedCell
        ? fullHeight + this._getCorruptedItemCellHeight(itemWidth)
        : fullHeight;

      return fullHeight;
    },

    _getNoteCellHeight(item) {
      const userId = this._getCueStateField('userId'),
        userSettings = this._getCueStateField('userSettings'),
        statePath = ['userSettings', userId, 'note', 'rteState'],
        formatPath = ['userSettings', userId, 'note', 'format'];

      const colWidth = this._getColumnWidth(
          userSettings.getIn(['noteColumn', 'width']),
        ),
        noteState = item.getIn(statePath) || '';

      const titleView = item.get('titleView');

      const classes = classNames('cs-note-cell', 'cs-cell', 'cs-cell-format', {
        'cs-title-cell': titleView,
      });

      const styles = this._getCellHeightCalcStyles();
      let calcHeight = this._getRowHeightWithErrorHandler(
        colWidth,
        noteState,
        styles,
        classes,
      );

      return calcHeight;
    },

    _getProofCellHeight(item) {
      const user = this.state.user;
      const displayProofOfPerformance = user.getIn([
        'preferences',
        'displayProofOfPerformance',
      ]);
      const proof = item.get('proof');

      if (!proof || !displayProofOfPerformance) return 0;

      return 62;
    },

    _getLabelsCellHeight(item, labels, rowId) {
      let labelNodes = '';

      labels.forEach((label) => {
        if (!label) return;

        labelNodes +=
          `<div class="cs-label-cell-content">` +
          `<div class="cs-label-inner">${label.get('text')}</div>` +
          `</div>`;
      });

      let markup = `<div class="cs-label-cell cs-cell">${labelNodes}</div>`;

      const calcHeight = this._getNonRTERowHeightWithErrorHandler(154, markup);

      return calcHeight;
    },

    _getCellHeight(cell, columnId, item) {
      const columns = this._getCueStateField('columns'),
        column = columns.get(columnId);

      //Column could be hidden or removed..
      if (!column) return defaultRowHeight;

      const colWidth = this._getColumnWidth(column.get('width'));

      let styles = this._getCellHeightCalcStyles();
      let cellFormat = cell.get('format');

      if (cellFormat && cellFormat.get('uppercase'))
        styles.textTransform = 'uppercase';

      const titleView = item.get('titleView');

      const classes = classNames('cs-data-cell', 'cs-cell', 'cs-cell-format', {
        'cs-title-cell': titleView,
      });

      let calcHeight = this._getRowHeightWithErrorHandler(
        colWidth,
        cell.get('rteState'),
        styles,
        classes,
      );

      return calcHeight;
    },

    /**
     * Get the data for a 'item' cell (which is actually composed of several fields)
     *
     */
    _rowDataGetter(key, rowData) {
      return rowData;
    },

    _itemCellNumberRenderer(rowSpec, cellDataKey, rowIndex) {
      const item = this._getRowItem(rowSpec);

      return (
        <div style={{ color: 'white' }}>
          <span>{item.get('numberAdjusted')} Loading....</span>
        </div>
      );
    },

    /**
     * Renderer for the label cell
     */
    _labelCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
      if (this._isFooterRow(rowIndex)) return this._emptyCellRenderer();

      const item = this._getRowItem(rowSpec),
        show = this._getCueStateField('show'),
        event = this.state.event,
        user = this.state.user,
        settings = this._getCueStateField('settings'),
        titleView = item.get('titleView'),
        globalElements = this.state.globalElements,
        tags = globalElements.get('tags'),
        rowTags = this._getRowTagsByRowIndex(rowIndex);

      //let width = isCompactView ? getCompactItemCellWidthName(settings) : getItemCellWidthName(settings);
      //if (isGlobalElementView) width = getGlobalItemCellWidthName();

      const itemProps = {
        item,
        user,
        rowIndex,
        displayType: show.get('displayType'),
        userId: this._getCueStateField('userId'),
        titleRow: rowSpec.get('type') === RowTypes.TitleItem,
        tags,
        rowTags,
      };

      return (
        <LabelCell
          {...itemProps}
          isCopied={rowSpec.get('copied')}
          editing={rowSpec.getIn(['editing', 'type'])}
          rowSelected={rowSpec.get('rowSelected')}
          rowType={rowSpec.get('type')}
        />
      );
    },

    _rowMenuCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
      if (this._isFooterRow(rowIndex)) return this._emptyCellRenderer();

      const item = this._getRowItem(rowSpec),
        show = this._getCueStateField('show'),
        event = this.state.event,
        user = this.state.user,
        titleView = item.get('titleView'),
        globalElements = this.state.globalElements,
        tags = globalElements.get('tags'),
        activeTags = this._getRowTagsByRowIndex(rowIndex);

      /**
       * If row filtered is applied then disable row re-ordering.
       * Primarily applies to global element editor
       */
      const unfilteredRows = this._getCueStateField('unfilteredRows'),
        rows = this._getCueStateField('rows'),
        disableReordering =
          isGlobalElementView &&
          unfilteredRows &&
          unfilteredRows.size > rows.size
            ? true
            : false;

      const itemProps = {
        item,
        user,
        rowIndex,
        userId: this._getCueStateField('userId'),
        tags,
        activeTags,
      };

      return (
        <RowMenuCell
          {...itemProps}
          checkSelectionStatus={(type) =>
            CuesheetHelper.isCellSelected(rowIndex, type, this.state.cuesheet)
          }
          rowSelected={rowSpec.get('rowSelected')}
          rowType={rowSpec.get('type')}
          disableReordering={disableReordering}
        />
      );
    },

    /**
     * Renderer for the item cell
     */
    _itemCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
      if (!isGlobalElementView && this.state.userStartedScrolling) {
        this._setLatestRenderedRowIndex(rowIndex);
      }

      if (this._isFooterRow(rowIndex)) {
        return (
          <div className="cs-rows-add-btn-container">
            <AddItemButton />
          </div>
        );
      }

      const { cuesheet, event, user } = this.state;

      const item = this._getRowItem(rowSpec, cuesheet),
        trackedUsers = rowSpec.get('trackedUsers'),
        show = this._getCueStateField('show'),
        settings = this._getCueStateField('settings'),
        titleView = item.get('titleView');

      let width = isCompactView
        ? getCompactItemCellWidthName(settings)
        : getItemCellWidthName(settings);
      if (isGlobalElementView) width = getCompactItemCellWidthName(settings);

      const height = this._cellHeightGetter(rowIndex, titleView);

      const itemProps = {
        eventId: event.get('_id'),
        teamId: event.get('team'),
        item,
        user,
        height,
        showStartOn: show.get('startOn'),
        itemNumber: item.get('numberAdjusted'),
        rowIndex,
        rowId: rowSpec.get('path')[2],
        timeZone: event.get('timeZone'),
        twentyFourHourClock: event.get('twentyFourHourClock'),
        displayType: show.get('displayType'),
        displayStartTime: show.get('displayStartTime'),
        startOn: item.get('startOn'),
        displayStartTimeClock: item.get('displayStartTimeClock'),
        displayActualDuration: show.get('displayActualDuration'),
        displayDuration: show.get('displayDuration'),
        displayPresetDuration: show.get('displayPresetDuration'),
        durationInSeconds: item.get('durationInSeconds'),
        presetDurationInSecondsAdjusted: item.get(
          'presetDurationInSecondsAdjusted',
        ),
        durationDisplayType: show.get('durationDisplayType'),
        presetDurationDisplayType: show.get('presetDurationDisplayType'),
        autoCountCues: show.get('autoCountCues'),
        autoTimeCalculation: show.get('autoTimeCalculation'),
        displayDescriptions: this._getCueState().getIn([
          'show',
          'displayItemDescriptions',
        ]),
        userId: this._getCueStateField('userId'),
        titleRow: rowSpec.get('type') === RowTypes.TitleItem,
        trackedUsers,
        width,
        itemCollabCell: CuesheetHelper.isCollabCell(
          rowIndex,
          EditableCellTypes.ItemTitle,
          cuesheet,
        ),
        descriptionCollabCell: CuesheetHelper.isCollabCell(
          rowIndex,
          EditableCellTypes.ItemDescription,
          cuesheet,
        ),
      };

      return (
        <ItemCellComponent
          {...itemProps}
          isTracked={rowSpec.get('tracked')}
          isCopied={rowSpec.get('copied')}
          isTitleCopied={this.isCellCopied(
            rowIndex,
            EditableCellTypes.ItemTitle,
          )}
          isDescriptionCopied={this.isCellCopied(
            rowIndex,
            EditableCellTypes.ItemDescription,
          )}
          editing={rowSpec.getIn(['editing', 'type'])}
          checkSelectionStatus={(type) =>
            CuesheetHelper.isCellSelected(rowIndex, type, cuesheet)
          }
          rowSelected={rowSpec.get('rowSelected')}
          rowType={rowSpec.get('type')}
        />
      );
    },

    _startTimeCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
      const { event, user, cuesheet } = this.state;

      if (!rowSpec.get) return <span />;

      const item = this._getRowItem(rowSpec);

      return startTimeCellRenderer(item, rowIndex, user, event, cuesheet);
    },

    _durationCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
      const { event, user, cuesheet } = this.state;

      if (!rowSpec.get) return <span />;

      const item = this._getRowItem(rowSpec);

      return durationCellRenderer(
        item,
        rowSpec,
        rowIndex,
        user,
        event,
        cuesheet,
      );
    },

    _presetDurationCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
      const { event, user, cuesheet } = this.state;

      if (!rowSpec.get) return <span />;

      const item = this._getRowItem(rowSpec);

      return presetDurationCellRenderer(item, rowIndex, event, user, cuesheet);
    },

    _proofOfPerformanceRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
      if (!rowSpec.get) return <span />;

      const event = this.state.event;
      let item = this._getRowItem(rowSpec);

      return (
        <ProofOfPerformanceCell
          cellHeight={this._cellHeightGetter(rowIndex)}
          timeZone={event.get('timeZone')}
          twentyFourHourClock={event.get('twentyFourHourClock')}
          rowIndex={rowIndex}
          rowId={rowSpec.get('path')[2]}
          item={item}
          user={this.state.user}
        />
      );
    },

    /**
     * Render a note cell
     *
     */
    _noteCellRenderer(rowSpec, cellDataKey, rowData, rowIndex) {
      const state = this.state.cuesheet,
        show = state.get('show'),
        rows = this._getRows(),
        userSettings = state.get('userSettings'),
        width = getNoteCellWidthName(userSettings);

      if (rows.size <= rowIndex) {
        return this._emptyCellRenderer();
      }

      const item = this._getRowItem(rowSpec);

      const titleView = item.get('titleView');

      const height = this._cellHeightGetter(rowIndex, titleView);

      const itemProps = {
        item,
        rowId: rowSpec.get('path')[2],
        rowIndex,
        width,
        height,
        displayType: show.get('displayType'),
        userId: this._getCueStateField('userId'),
      };

      let isEditing =
          rowSpec.getIn(['editing', 'type']) === EditableCellTypes.ItemNote,
        isCopied = this.isCellCopied(rowIndex, EditableCellTypes.ItemNote),
        isSelected = CuesheetHelper.isCellSelected(
          rowIndex,
          EditableCellTypes.ItemNote,
          state,
        );

      return (
        <NoteCell
          {...itemProps}
          isSelected={isSelected}
          isEditing={isEditing}
          isCopied={isCopied}
        />
      );
    },

    /**
     * Get data for a 'data' cell
     *
     */
    _dataCellDataGetter(columnId, rowSpec) {
      //If there is no rowSpec then this is the footer row.
      if (!rowSpec.size) return {};

      const item = this._getRowItem(rowSpec);
      return item.getIn(['cells', columnId]);
    },

    _emptyCellRenderer() {
      return <span />;
    },

    /**
     * Render a 'data' cell
     *
     */
    _dataCellRenderer(cell, columnId, rowSpec, rowIndex, columnData) {
      const state = this.state.cuesheet,
        rows = this._getRows(),
        show = state.get('show');

      if (rows.size <= rowIndex) {
        return this._emptyCellRenderer();
      }

      const item = this._getRowItem(rowSpec),
        userId = this._getCueStateField('userId'),
        rowType = rowSpec.get('type'),
        isCopied =
          rowSpec.get('copied') || this.isCellCopied(rowIndex, columnId),
        isEditing = rowSpec.getIn(['editing', 'value']) === columnId,
        isSelected = CuesheetHelper.isCellSelected(rowIndex, columnId, state),
        collabCell = CuesheetHelper.isCollabCell(rowIndex, columnId, state),
        width = getDataCellWidthName(state.getIn(['columns', columnId])),
        displayType = show.get('displayType');

      const titleView = item.get('titleView');

      const height = this._cellHeightGetter(rowIndex, titleView);

      const rowId = rowSpec.get('path')[2];

      const itemProps = {
        rowId,
        columnId,
        cell,
        rowType,
        rowIndex,
        item,
        userId,
        isCopied,
        isEditing,
        isSelected,
        width,
        height,
        displayType,
        collabCell,
      };

      return <DataCell {...itemProps} />;
    },

    _setLatestRenderedRowIndex(rowIndex) {
      if (this.setLatestRenderedRowIndex)
        clearTimeout(this.setLatestRenderedRowIndex);

      /**
       * This timeout prevents rapid firing of this GlobalElementModalAction
       * from firing rapidly while user is scrolling quickly.
       *
       * We only want to capture the last row index once their scrolling has
       * dramatically slowed or stopped.
       */
      this.setLatestRenderedRowIndex = setTimeout(() => {
        GlobalElementModalActions.setLatestRenderedRowIndex(rowIndex);
      }, 300);
    },

    /**
     * Get the column width for an item column
     */
    _getItemColumnWidth() {
      const settings = this._getCueStateField('settings');

      return CuesheetHelper.getItemColumnWidth(
        settings,
        isCompactView || isGlobalElementView,
      );
    },

    /**
     * Corrupted cells do not correctly generate a row height. We
     * have pre-defined values to correctly display the corrupted
     * cell content message.
     */
    _getCorruptedItemCellHeight(width) {
      const heightLookup = {
        [ItemColumnSegmentWidths.UltraNarrow]: 100,
        [ItemColumnSegmentWidths.Narrow]: 175,
        [ItemColumnSegmentWidths.Normal]: 250,
        [ItemColumnSegmentWidths.Wide]: 400,
        [ItemColumnSegmentWidths.ScriptWide]: 600,
      };

      return heightLookup[width];
    },

    _getRowHeightWithErrorHandler(
      width,
      rteState,
      styles,
      className,
      errorHandler,
    ) {
      let height = 0;

      /**
       * Prevent show from breaking when cell is corrupted.
       * Check renderable content of cell to retrieve cell height.
       */
      try {
        height = RowHeightHelper.getHeight(width, rteState, styles, className);
      } catch (e) {
        if (errorHandler) errorHandler();
      }

      return height;
    },

    _getNonRTERowHeightWithErrorHandler(width, markup, errorHandler) {
      let height = 0;

      /**
       * Prevent show from breaking when cell is corrupted.
       * Check renderable content of cell to retrieve cell height.
       */
      try {
        height = RowHeightHelper.getNonRTEHeight(width, markup);
      } catch (e) {
        if (errorHandler) errorHandler();
      }

      return height;
    },
  });
};

export default cuesheetHoc;
